<template>
  <pagefra
    v-loading.fullscreen="deriveLoading"
    :element-loading-text="$l('生成中...')"
  >
    <div class="report-box" id="domain-weekly" v-loading.fullscreen="loading">
      <div class="report-item-box">
        <div class="report-title">
          <div class="title-l">
            <label class="back" v-if="!deriveLoading" @click="$router.go(-1)"
              ><i class="el-icon-arrow-left"></i>{{ $l("返回") }}
            </label>
            <strong>{{ $l("电梯基本信息") }} </strong>
            <span></span>
          </div>
          <div class="title-r">
            <el-button
              type="primary"
              round
              v-if="!deriveLoading"
              @click="handleDerive"
              class="download"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
        <div class="content-box">
          <div class="info-box">
            <div class="code-item">
              <span>{{ $l("所在城市：") }} {{ form.city }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("地盘名称：") }} {{ form.domainName }}</span>
            </div>
            <div class="code-item">
              <span
                >{{ $l("报告确认时间：") }}
                {{ form.confirmTime.split(" ")[0] }}</span
              >
            </div>
            <div class="code-item">
              <span class="ti-input" v-if="!deriveLoading"
                >{{ $l("电梯管理员：") }}

                <el-input
                  v-model="form.adminName"
                  placeholder="请输入"
                  maxlength="20"
                />
              </span>
              <span class="ti-input" v-else
                >{{ $l("电梯管理员：") }} {{ form.adminName }}
              </span>
            </div>
            <div class="code-item">
              <span
                >{{ $l("台量：") }}
                {{ form.liftCount + form.escalatorCount }}</span
              >
            </div>
            <div class="code-item">
              <span>{{ $l("扶梯：") }} {{ form.escalatorCount }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("直梯：") }} {{ form.liftCount }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section-box">
        <div class="section-l">
          <div class="report-item-box">
            <div class="report-title">
              <div class="title-l">
                <strong>{{ $l("电梯设备运行状态") }} </strong>
                <i class="unit">{{ $l("(单位：台)") }} </i>
              </div>
              <div class="title-r"></div>
            </div>
            <div class="content-box">
              <div class="echart-box" id="device-run"></div>
            </div>
          </div>
        </div>
        <div class="section-r">
          <div class="report-item-box">
            <div class="report-title">
              <div class="title-l">
                <strong>{{ $l("电梯内部安全情况") }} </strong>
                <i class="unit">{{ $l("(单位：台)") }}</i>
              </div>
              <div class="title-r"></div>
            </div>
            <div class="content-box">
              <div class="echart-box security-box">
                <div class="echart" id="interior-echart"></div>
                <div class="legend-box">
                  <div
                    class="item"
                    v-for="(item, index) in form.elevatorInnerStatusList"
                    :key="index"
                  >
                    <span>{{ $l(item.text) }}</span>
                    <label>{{ item.percent }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-box">
        <div class="section-l">
          <div class="report-item-box">
            <div class="report-title">
              <div class="title-l">
                <strong>{{ $l("电梯外部安全情况") }} </strong>
                <i class="unit">{{ $l("(单位：台)") }}</i>
              </div>
              <div class="title-r"></div>
            </div>
            <div class="content-box">
              <div class="echart-box security-box">
                <div class="echart" id="external-echart"></div>
                <div class="legend-box">
                  <div
                    class="item"
                    v-for="(item, index) in form.elevatorOuterStatusList"
                    :key="index"
                  >
                    <span>{{ $l(item.text) }}</span>
                    <label>{{ item.percent }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-r">
          <div class="report-item-box">
            <div class="report-title">
              <div class="title-l">
                <strong>{{ $l("小区应急救援设施情况") }} </strong>
                <i class="unit">{{ $l("(单位：台)") }}</i>
              </div>
              <div class="title-r"></div>
            </div>
            <div class="content-box">
              <div class="echart-box" id="emergency-echart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pagefra>
</template>

<script>
import echarts from "echarts";
import dayjs from "dayjs";
dayjs.extend(require("dayjs/plugin/weekOfYear"));
import global from "@/mixins/global.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapGetters } from "vuex";
export default {
  mixins: [global],
  data() {
    return {
      colors: ["#30c9c9", "#f7ba1e", "#df4545", "#cccccc"],
      deviceRunRef: null,
      emergencyRef: null,
      internalRef: null,
      externalRef: null,
      form: {
        city: "",
        domainName: "",
        confirmTime: "",
        adminName: "",
        liftCount: "",
        escalatorCount: "",
        escalatorCount: "",
        liftCount: "",
        elevatorRunStatusList: [],
        elevatorInnerStatusList: [],
        elevatorOuterStatusList: [],
        estateRescueFacilityStatusList: [],
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["deriveLoading"]),
  },
  created() {
    const { query } = this.$route;
    this.params = query;
    if (query.startTime) {
      this.$route.meta.subtitle =
        query.reportType == 1
          ? `（${dayjs(query.startTime).format("YYYY年MM月DD日")} ${this.$l("至")} ${dayjs(
              query.endTime
            ).format("YYYY年MM月DD日")}）`
          : `（${dayjs(query.startTime).format("YYYY年MM月")}）`;
    }
    this.loadReportData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    loadReportData() {
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_elevator_statistics_domain, {
          params: this.params,
        })
        .then((response) => {
          let result = response.data;
          console.log(result);
          this.loading = false;
          if (result.code == 0) {
            this.form = result.data;
            const {
              elevatorRunStatusList,
              elevatorInnerStatusList,
              elevatorOuterStatusList,
              estateRescueFacilityStatusList,
            } = this.form;
            if (this.form.noReports > 0) {
              return this.$alert(
                `${
                  this.params.reportType == 1
                    ? this.$l("本周")
                    : this.$l("本月")
                }${
                  this.$l("有") +
                  this.form.noReports +
                  this.$l("份未提交日报，请先提交日报！")
                }`,
                this.$l("提示"),
                {
                  confirmButtonText: this.$l("确定"),
                  callback: (action) => {
                    this.$router.go(-1);
                  },
                }
              );
            }
            this.setDeviceRun(elevatorRunStatusList);
            this.form.elevatorInnerStatusList = this.constitutePercent(
              elevatorInnerStatusList
            );
            this.form.elevatorOuterStatusList = this.constitutePercent(
              elevatorOuterStatusList
            );
            this.setInternalSecurity(this.form.elevatorInnerStatusList);
            this.setExternalSecurity(this.form.elevatorOuterStatusList);
            this.setEmergencyDevice(estateRescueFacilityStatusList);
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    constitutePercent(list) {
      const states = ["安全", "隐患", "待确认"];
      const total = list.reduce((a, b) => a + b, 0);
      return list.map((v, i) => {
        return {
          total: total.toFixed(2),
          percent: ((v / total) * 100).toFixed(2),
          value: v,
          text: states[i],
        };
      });
    },
    handleResize() {
      this.deviceRunRef && this.deviceRunRef.resize();
      this.emergencyRef && this.emergencyRef.resize();
      this.internalRef && this.internalRef.resize();
      this.externalRef && this.externalRef.resize();
    },
    /* 柱状图 */
    getBarOption(data) {
      return {
        grid: {
          top: "10%",
          left: 10,
          right: 10,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [this.$l("正常"), this.$l("维修"), this.$l("停用"), this.$l("待确认")],
          axisLabel: {
            color: "#86909c",
            fontSize: 14,
          },
          axisLine: {
            lineStyle: {
              color: "#c9cdd4",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#86909c",
          },
        },
        series: [
          {
            data: data,
            type: "bar",
            barWidth: 30,
            itemStyle: {
              color: (t) => {
                return this.colors[t.dataIndex];
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#000",
              fontSize: 14,
            },
          },
        ],
      };
    },
    /* 设备运行情况 */
    setDeviceRun(data) {
      let chartDom = document.getElementById("device-run");
      this.deviceRunRef = echarts.init(chartDom);
      let option = this.getBarOption(data);
      this.deviceRunRef.setOption(option, true);
    },
    /* 小区应急救援设施情况 */
    setEmergencyDevice(data) {
      let chartDom = document.getElementById("emergency-echart");
      this.emergencyRef = echarts.init(chartDom);
      let option = this.getBarOption(data);
      this.emergencyRef.setOption(option, true);
    },
    /* 饼图 */
    getPieOption(data) {
      return {
        backgroundColor: "#fff",
        title: [
          {
            text: this.$l("总数"),
            left: "center",
            top: "38%",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              color: "#5c5c5c",
              align: "center",
            },
          },
          {
            text: parseInt(data[0].total),
            left: "center",
            top: "52%",
            textStyle: {
              fontSize: 18,
              color: "#000",
              align: "center",
            },
          },
        ],
        tooltip: {
          confine: true,
          enterable: false,
          type: "axis",
          formatter: "{c}",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["70%", "90%"],
            hoverAnimation: true,
            color: ["#30c9c9", "#df4545", "#cccccc"],
            label: {
              normal: {
                show: false,
                textStyle: {
                  fontSize: 18,
                },
                formatter: function (params, ticket, callback) {
                  return params.value;
                },
              },
            },
            data: data.map((v) => v.value),
          },
        ],
      };
    },
    /* 电梯内部安全情况 */
    setInternalSecurity(data) {
      let chartDom = document.getElementById("interior-echart");
      this.internalRef = echarts.init(chartDom);
      let option = this.getPieOption(data);
      this.internalRef.setOption(option, true);
    },
    /* 外部安全情况 */
    setExternalSecurity(data) {
      let chartDom = document.getElementById("external-echart");
      this.externalRef = echarts.init(chartDom);
      let option = this.getPieOption(data);
      this.externalRef.setOption(option, true);
    },
    /* 导出 */
    handleDerive() {
      this.$store.commit("setDeriveLoading", true);
      this.$nextTick(() => {
        const elementToExport =
          document.getElementsByClassName("pagefra-main")[0];
        elementToExport.style.height =
          112 + document.getElementById("domain-weekly").scrollHeight + "px";
        html2canvas(elementToExport, {
          useCORS: true,
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(
              `${this.$route.meta.title + this.$route.meta.subtitle + '_' + this.form.domainName}.pdf`
            );
            elementToExport.style.height = "auto";
            this.$store.commit("setDeriveLoading", false);
          })
          .catch((err) => {
            console.log(err);
            this.$store.commit("setDeriveLoading", false);
            elementToExport.style.height = "auto";
            this.message(500, "导出失败");
          });
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped lang="scss">
.report-box {
  padding: 0 20px;
}

.report-item-box {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;

  .report-title {
    height: 66px;
    padding: 15px 20px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-l {
      color: #5c5c5c;

      strong {
        font-size: 18px;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }

  .content-box {
    padding: 15px 20px;

    span,
    label {
      font-size: 14px;
      color: #5c5c5c;
    }
  }
}

.info-box {
  display: flex;
  flex-wrap: wrap;

  .code-item {
    width: 25%;
    line-height: 2.5;
  }
}

.section-box {
  display: flex;

  & > div {
    &:first-child {
      flex: 1;
    }

    &:last-child {
      width: 50%;
      margin-left: 18px;
    }
  }
}

.echart-box {
  height: 210px;
  display: flex;
}

.security-box {
  margin: 0 auto;
  display: flex;
  width: 60%;
  min-width: 400px;

  .echart {
    width: 50%;
  }

  .legend-box {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 5px;

    .item {
      display: flex;
      align-items: center;
      padding: 20px 20px;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        height: 50%;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 4px;
        border-radius: 2px;
        background-color: #30c9c9;
      }

      &:nth-child(2)::before {
        background-color: #df4545;
      }

      &:nth-child(3)::before {
        background-color: #cccccc;
      }

      span {
        width: 120px;
        font-size: 15px;
      }

      label {
        font-size: 20px;
        color: #1d2129;
        font-weight: 700;
        position: relative;

        &::after {
          content: "%";
          position: absolute;
          right: -14px;
          color: #86909c;
          font-size: 12px;
          bottom: 0;
        }
      }
    }
  }
}

.unit {
  font-style: normal;
}

.ti-input {
  display: flex;
  align-items: center;

  .el-input {
    width: 100px;
  }
}

.back {
  margin-right: 15px;
  cursor: pointer;
}
</style>